import React from 'react';

const SummaryIcon = React.memo(({ width = '24', height = '24' }) => (
  <div
    style={{ width, height, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}
  >
    <svg
      width={'14'}
      height={'14'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-text-search"
    >
      <path d="M21 6H3" />
      <path d="M10 12H3" />
      <path d="M10 18H3" />
      <circle cx="17" cy="15" r="3" />
      <path d="m21 19-1.9-1.9" />
    </svg>
  </div>
));

export default SummaryIcon;
